export default {
  title: 'Sulje saatavuus',
  close_availabilities_form: {
    date_range: {
      label: 'Valitse päivämäärä ja kellonaika.',
    },
  },
  reason: {
    label: 'Lisää syy (valinnainen)',
    placeholder: 'Kirjoita kuvaus...',
  },
  recurring: {
    label: 'Toistuu vuosittain',
  },
  buttons: {
    save: 'Tallenna',
    cancel: 'Peruuta',
    add: '+ Lisää poikkeus',
    reactivate: 'Aktivoi uudelleen',
  },
  reservations: {
    title: 'Varaukset',
    description: 'Haluatko lisätä aikataulupoikkeuksen varauksiin?',
    add: 'Lisää',
    cancel: 'Peruuta',
  },
  projects: {
    online_shop: 'Verkkokauppa',
    reservations: 'Varaukset',
    storefront: 'Storefront',
  },
  success_messages: {
    reservation_updated: 'Aikataulupoikkeus lisätty onnistuneesti',
  },
  error_messages: {
    date_range_required: 'Valitse päivämääräväli.',
    creation_failed: 'Poikkeuksen luominen epäonnistui',
    overlapping_schedule_exception: 'Sinulla on jo aikataulupoikkeus tälle ajanjaksolle',
    merge_schedule_exceptions:
      'Seuraava aikataulupoikkeus {{oldDate}} yhdistetään poikkeukseen {{newDate}}. Voit myös päivittää päivämääräväliä kohteelle {{oldDate}}.',
  },
};
